import React from 'react';
import ServicePageShell from '../components/ServicePageShell';
import SystemeAffectationStatic from './SystemeAffectationStatic';

const SystemeAffectation = () => (
  <ServicePageShell
    strapiApiId="postes-systeme-affectation"
    defaultSectionLabel="Postes"
    defaultTitle="Système d’affectation"
    StaticFallback={SystemeAffectationStatic}
  />
);

export default SystemeAffectation;
